import { getYear } from 'date-fns';
import { memo } from 'react';
import { Text, VStack } from 'native-base';

export function Footer() {
  const currentDate = new Date();
  const currentYear = getYear(currentDate);

  return (
    <VStack textAlign={'center'} space={3} mt={3}>
      <Text color={'surface.500'}>
        © {currentYear} birdhaus Platforms, LLC. All Rights Reserved.
      </Text>
      <Text color={'white'} fontWeight={600}>
        Made with{' '}
        <span color={'red.200'} role="img" aria-label="heart-emoji">
          ❤️
        </span>{' '}
        in NYC 🗽
      </Text>
    </VStack>
  );
}

export default memo(Footer);
